module.exports = __webpack_public_path__ + "static/media/ke.bedda23f.svg";